// extracted by mini-css-extract-plugin
export default {"foutmelding":"GetUsername_foutmelding__uM8ui","melding":"GetUsername_melding__DVA8W"};